export class MvaPriceUtils {
  static MVA_RATE = 0.15;

  static roundPrice(value) {
    return Math.round((value + Number.EPSILON) * 100) / 100;
  }

  static getNumericValue(value) {
    if (value === '' || value === null || value === undefined) {
      return null;
    }

    const numericValue = Number(value);
    return Number.isFinite(numericValue) ? numericValue : null;
  }

  static formatPrice(value) {
    const numericValue = MvaPriceUtils.getNumericValue(value);
    return numericValue === null ? '-' : numericValue.toFixed(2);
  }

  static formatEditablePrice(value) {
    const numericValue = MvaPriceUtils.getNumericValue(value);
    return numericValue === null ? '' : numericValue.toFixed(2);
  }

  static getAmountExcludingMva(priceInfo) {
    const amountExcludingMva =
      MvaPriceUtils.getNumericValue(priceInfo?.priceExcludingVat) ??
      MvaPriceUtils.getNumericValue(priceInfo?.amount);

    if (amountExcludingMva !== null) {
      return amountExcludingMva;
    }

    const amountIncludingMva = MvaPriceUtils.getNumericValue(
      priceInfo?.amountIncludingMva
    );

    return amountIncludingMva === null
      ? null
      : MvaPriceUtils.roundPrice(
          amountIncludingMva / (1 + MvaPriceUtils.MVA_RATE)
        );
  }

  static getMvaAmount(priceInfo) {
    const amountIncludingMva = MvaPriceUtils.getNumericValue(
      priceInfo?.amountIncludingMva
    );

    if (amountIncludingMva !== null) {
      const amountExcludingMva = MvaPriceUtils.getAmountExcludingMva({
        amountIncludingMva,
      });

      return amountExcludingMva === null
        ? null
        : MvaPriceUtils.roundPrice(amountIncludingMva - amountExcludingMva);
    }

    const amountExcludingMva = MvaPriceUtils.getAmountExcludingMva(priceInfo);

    return amountExcludingMva === null
      ? null
      : MvaPriceUtils.roundPrice(
          amountExcludingMva * MvaPriceUtils.MVA_RATE
        );
  }

  static getAmountIncludingMva(priceInfo) {
    const amountIncludingMva = MvaPriceUtils.getNumericValue(
      priceInfo?.amountIncludingMva
    );

    if (amountIncludingMva !== null) {
      return MvaPriceUtils.roundPrice(amountIncludingMva);
    }

    const amountExcludingMva = MvaPriceUtils.getAmountExcludingMva(priceInfo);
    const mvaAmount = MvaPriceUtils.getMvaAmount(priceInfo);

    return amountExcludingMva === null || mvaAmount === null
      ? null
      : MvaPriceUtils.roundPrice(amountExcludingMva + mvaAmount);
  }

  static getAmountSplit(priceInfo) {
    return {
      amount: MvaPriceUtils.getAmountExcludingMva(priceInfo),
      vatAmount: MvaPriceUtils.getMvaAmount(priceInfo),
      amountIncludingMva: MvaPriceUtils.getAmountIncludingMva(priceInfo),
    };
  }

  static getDraftValues(priceInfo) {
    return {
      amount: MvaPriceUtils.formatEditablePrice(
        MvaPriceUtils.getAmountExcludingMva(priceInfo)
      ),
      amountIncludingMva: MvaPriceUtils.formatEditablePrice(
        MvaPriceUtils.getAmountIncludingMva(priceInfo)
      ),
    };
  }
}

export default MvaPriceUtils;
